import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GeneralSettingsRoutingModule } from './general-settings-routing.module';
import { DxDataGridModule, DxTextAreaModule, DxPopupModule } from 'devextreme-angular';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';
import { SettingsService } from '../settings.service';
import { GeneralSettingsComponent } from './general-settings.component';

@NgModule({
  declarations: [GeneralSettingsComponent],
  imports: [
    CommonModule,
    GeneralSettingsRoutingModule,
    DxDataGridModule,
    DevEpressCommonModule,
    DxTextAreaModule,
    DxPopupModule,
  ],
  providers: [SettingsService]
})
export class GeneralSettingsModule { }
